import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faBan,
  faFont,
} from "@fortawesome/pro-regular-svg-icons";
import Button from "./ToolbarButton";
import { ToolbarWrap, Separator } from "./ToolbarUtils";
import { useEditorContext } from "./EditorContext";
import CustomConfigurator from "../../../CustomConfigurator";

interface TextColorToolbarProps {
  isActive: (color: string | null) => boolean;
  canExec: boolean;
  onSetColor: (color: string | null) => void;
  onBack: () => void;
}

export default function TextColorToolbar({
  isActive,
  canExec,
  onSetColor,
  onBack,
}: TextColorToolbarProps) {
  const { readOnly } = useEditorContext();

  return (
    <ToolbarWrap>
      <Button
        onClick={onBack}
        tooltip={I18n.t("js.composer.editor.buttons.back_to_toolbar")}
        disabled={readOnly}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>

      <Separator />

      <Button
        pressed={isActive(null)}
        disabled={readOnly || !canExec}
        onClick={() => onSetColor(null)}
        tooltip={I18n.t("js.composer.editor.buttons.no_colors")}
      >
        <FontAwesomeIcon icon={faBan} />
      </Button>

      {CustomConfigurator.get("markdownEditor.colors").map(
        ({ label, style: color }) => (
          <Button
            key={color}
            pressed={isActive(color)}
            disabled={readOnly || !canExec}
            onClick={() => onSetColor(color)}
            tooltip={label()}
          >
            <span style={{ color }}>
              <FontAwesomeIcon icon={faFont} />
            </span>
          </Button>
        ),
      )}
    </ToolbarWrap>
  );
}
